import app from '../app.first';
import $ from 'jquery';
import 'foundation-datepicker';
import _ from 'lodash';

app.EducationDetails = class extends app.Component {
	constructor($this) {
        super($this);
        this.subjectCount = 0;
        this.fieldCount = 0;
        this.isTertiary = false;
        //This is the DOM element TAKE NOTE!!!!!
        this.$qualificationObjects = $('#user-detail-qualifications-0');
        //An array of Objects. Note that this is JSON, whereas the $ variation before is the jQuery element representing DOM element
        let jsonObject = this.$qualificationObjects.val().length < 3 ? "[{}]" : this.$qualificationObjects.val();
        this.qualificationObjects = $.parseJSON(jsonObject);

        //Initial sections that events need to be assigned to and sections to be cloned, etc
        this.qualificationId = $('#user-detail-qualifications-0-id').val();
        this.$educationLevel = $('#education_level');
        this.$addField = $('#add-field');
        this.$matricSection = $('#matric');
        this.$tertiarySection = $('#tertiary');
        this.$originalContent = $('.original-wrapper').clone();

        //High School specific selectors
        this.$highSchoolTitle = $('#user-detail-qualifications-0-institution-title');
        this.$hiddenSubjectsTaken = $('.subject-title-wrapper');
        this.$duplicatedSubjectsSection = $('#subjects');
        this.$documentUpload = $('.hidden-file-upload');
        this.$subjectsDropdown = $('.subjects');

        //Tertiary specific selectors
        this.$institutionType = $('.institution-type');
        this.$institutionTitle = $('.institution');
        this.$institutionField = $('.field-of-study');
        this.$institutionStartDate = $('.start-date');
        this.$institutionEndDate = $('.end-date');
        this.$institutionStillInProgress = $('.still-in-progress');
        this.$additionalFields = $('#ed_another_fields');

        this.$form = $('#education_details_form');
        this.$fileUploads = $('[type="file"]');

        //Fire the onReady event
        $(() => this.onDocumentReady());
	}

    onDocumentReady() {
        this.assignValidation(this.qualificationObjects[0]['qualification_level_id']);
        this.assignEventListeners();
        this.assignSubjectEventListeners();
        if (this.qualificationObjects.length > 0) {
            this.initPreviousQualifications();
            $('.button-dprimary').prop("disabled", false);
        }
        else {
            this.$educationLevel.trigger('change');
        }
    }

    assignValidation(qualificationLevelId) {
        $('.button-dprimary').prop("disabled", true);
        if (qualificationLevelId < 4 || qualificationLevelId == 10) {
            $('.button-dprimary').prop("disabled", false);
        }  else if (qualificationLevelId < 5) {
            let textCheck = false;
            let arrCheck = false;
            $('.force-update-high').on('change', () => {
                $('.force-update-high').each(function() {
                    Array.isArray($(this).val()) ? arrCheck = $(this).val().length !== 0 : textCheck = $(this).val() !== '';
                    $('.button-dprimary').prop("disabled", !(textCheck && arrCheck));
                })
            })
        } else {
            this.addOptionToQualification(0, 'institution_type_id', $('.institution-type').val())
            let check = false;
            $('.force-update-tert').on('change', () => {
                $('.force-update-tert').each(function() {
                    check = $(this).val().toString() !== '';
                    if (!check) {
                        $('.button-dprimary').prop("disabled", true);
                        return false;
                    } else {
                        $('.button-dprimary').prop("disabled", false);
                    }
                })
            })
        }
    }

    initDatePicker($selectorObject) {
        $selectorObject.fdatepicker({
            format: 'yyyy-mm-dd',
            initialDate: new Date()
        });
    }

    assignEventListeners() {
        //Component specific listeners
        this.$educationLevel.on('change', (e, data) => {
            let value = e.target.value;
            let clearFields = data == undefined ? true : data.clearFields;

            //Fire the event on the document so we can watch for it
            $(document).trigger('qualificationChange');

            this.manipulateSections(value, clearFields);
        });

        $('body').on('click', '.remove-button', (e) => {
            let $section = $(e.target).closest('.original-wrapper');
            let index = $(e.target).closest('[data-field]').data('field');
            this.removeOptionFromQualification(index);
            $section.remove();
        });

        this.$fileUploads.on('change', function() {
            let $this = $(this);
            $this.closest('.file').find('.file-name').html($this.val().split('\\').pop());
        });

        //Section specific event listeners
        //High School listeners
        this.$highSchoolTitle.on('change', (e) => {
            this.addOptionToQualification(0, 'institution_title', e.target.value);
        });

        $(document).on('click', '.visible-document-upload', (e) => {
            let $educationLevelWrapper = $(e.target).closest('[data-education-level]');
            let index = $educationLevelWrapper.find('.visible-document-upload').index(e.target);
            e.preventDefault();
            $($('.hidden-file-upload')[index]).trigger('click');
        });

        $(document).on('change', '.hidden-file-upload', (e) => {
            let index = $('.hidden-file-upload').index(e.target);

            let fileObject = e.target.files[0];
            let $fileInput = $($('[data-education-level]:visible .visible-document-upload')[index]);

            $fileInput.closest('.file').find('.filename').text(fileObject.name);

            //need to duplicate it as the File cannot be stringified
            this.addOptionToQualification(index, 'qualification_documents', {path: fileObject})
        });

        //Tertiary listeners
        this.$institutionType.on('change', (e) => {
            this.addOptionToQualification(0, 'institution_type_id', e.target.value);
        });

        this.$institutionTitle.on('change', (e) => {
            this.addOptionToQualification(0, 'institution_title', e.target.value);
        });

        this.$addField.on('click', () => {
            this.addAnotherField();
        });

        this.$institutionField.on('change', (e) => {
            let subjectText = e.target.value;
            //Means that there are no subjects in the object, so need to init it
            if (this.qualificationObjects[0]['subjects'] === undefined) {
                this.addOptionToQualification(0, 'subjects', []);
            }

            //Now check if the index exists or not and amend/add appropriately
            if (this.qualificationObjects[0]['subjects'][0] === undefined) {
                this.qualificationObjects[0]['subjects'].push({title: subjectText});
            } else {
                this.qualificationObjects[0]['subjects'][0] = {title: subjectText};
            }

            $(document).trigger('qualificationChange');
        });

        this.$institutionStartDate.on('change', (e) => {
            this.addOptionToQualification(0, 'start_date', e.target.value);
        });

        this.$institutionEndDate.on('change', (e) => {
            this.addOptionToQualification(0, 'end_date', e.target.value);
        });

        this.$institutionStillInProgress.on('change', (e) => {
            delete this.qualificationObjects[0]['end_date'];
            this.$institutionEndDate.attr('disabled', $(e.target).is(':checked')).val('');
            $(document).trigger('qualificationChange');
        });

        $(document).on('change', '.course', (e) => {
            let value = $(e.target).val();
            let index = $('.course').index(e.target);

            this.qualificationObjects[index]['course_studied'] = value;
            $(document).trigger('qualificationChange');
        });

        //Global event listeners
        $(document).on('qualificationChange', () => {
            this.$qualificationObjects.val(JSON.stringify(this.qualificationObjects));
        });

        $(document).on ('click', '.input.checkbox label', (e) => {
            $(e.target).siblings('input[type="checkbox"].still-in-progress').click();
        });
    }

    removeSubject(subjectToRemove) {
        _.remove(this.qualificationObjects[0]['subjects'], function(n) {
            return n.title === subjectToRemove;
        });

        $(document).trigger('qualificationChange');
    }

    removeOptionFromQualification(key) {
        delete this.qualificationObjects[key];
        $(document).trigger('qualificationChange');
    }

    addOptionToQualification(index, key, value) {
        if (typeof this.qualificationObjects[index] === 'undefined') {
            this.qualificationObjects.push({
                user_detail_id: this.qualificationObjects[index -1]['user_detail_id'],
                qualification_level_id: this.qualificationObjects[index -1]['qualification_level_id'],
                course_studied: null
            });
        }

        if (key !== null) {
            this.qualificationObjects[index][key] = value;
        }

        $(document).trigger('qualificationChange');
    }

    manipulateSections(qualificationLevelId, clearFields = true) {
        this.qualificationObjects[0]['qualification_level_id'] = qualificationLevelId;
        this.$qualificationObjects.val(JSON.stringify(this.qualificationObjects));

        //If ID less than 4, hide everything
        if (qualificationLevelId < 4 || qualificationLevelId == 10) {
            this.clearEducation(1, this.qualificationObjects.length, clearFields);
            this.qualificationObjects[0]['institution_title'] = null;
            this.qualificationObjects[0]['institution_type_id'] = null;
            this.qualificationObjects[0]['subjects'] = { "_ids": [] };
            this.qualificationObjects[0]['subjectsList'] = [];
            this.qualificationObjects[0]['qualification_documents'] = [];
            this.qualificationObjects[0]['start_date'] = [];
            this.qualificationObjects[0]['end_date'] = [];
            this.qualificationObjects[0]['course_studied'] = null;
            this.qualificationObjects[0]['qualification_level'] = null;
            this.$matricSection.addClass('hide');
            this.$tertiarySection.addClass('hide');
            this.isTertiary = false;
            this.$additionalFields.empty();
        }
        //If ID less than 5, show matric section
        else if (qualificationLevelId < 5) {
            this.clearEducation(1, this.qualificationObjects.length, clearFields);
            this.$matricSection.removeClass('hide');
            this.$tertiarySection.addClass('hide');
            this.qualificationObjects.length = 1;
            this.qualificationObjects[0]['institution_type_id'] = null;
            this.qualificationObjects[0]['start_date'] = [];
            this.qualificationObjects[0]['end_date'] = [];
            this.qualificationObjects[0]['course_studied'] = null;
            this.qualificationObjects[0]['qualification_level'] = null;
            this.isTertiary = false;
            this.$additionalFields.empty();
        }
        //Show tertiary and init DatePickers
        else {
            this.isTertiary = true;
            this.$matricSection.addClass('hide');
            this.$tertiarySection.removeClass('hide');
            this.initDatePicker(this.$institutionStartDate);
            this.initDatePicker(this.$institutionEndDate);
            $('.subjects').trigger('change');
        }
        this.assignValidation(qualificationLevelId);
        $(document).trigger('qualificationChange');
    }

    assignSubjectEventListeners() {
        this.$subjectsDropdown.on('change', (e) => {
            let values = $(e.target).val();
            this.qualificationObjects[0]['subjects'] = {
                //Need to check if it is single or multiple and patch accordingly
                _ids:  Array.isArray(values) ? values : [values]
            };

            $(document).trigger('qualificationChange');
        });
    }

    resetInputs($wrapper) {
        $wrapper.find('input').val('');
        $wrapper.find('checkbox').attr('checked', false);
    }

    initPreviousQualifications() {
        //Handle qualification level. It is the only one guaranteed to run, so no need to run any checks
        this.$educationLevel.val(this.qualificationObjects[0]['qualification_level_id']).trigger('change', {clearFields: false});

        if (this.$educationLevel.val() < 10 && this.$educationLevel.val() > 4) {
            let $currentSection;
            this.qualificationObjects.forEach((element, index) => {
                if (index > 0) {
                    $currentSection = this.addAnotherField();
                } else {
                    $currentSection = this.$tertiarySection.find('[data-field]').last();
                }
                $currentSection.find('.institution-type').val(element.institution_type_id).trigger('change');
                $currentSection.find('.institution').val(element.institution_title);

                if (element.subjectsList !== undefined && element.subjectsList !== null) {
                    $currentSection.find('.subjects').val(element.subjectsList[0]).trigger('change');
                }

                if (element.start_date !== undefined && element.start_date !== null && element.start_date.length > 0) {
                    $currentSection.find('.start-date').val(element.start_date.substr(0, 10));
                }


                if (element.end_date === null || element.end_date === undefined || element.start_date.length == 0) {
                    $currentSection.find('.still-in-progress').attr('checked', true).trigger('change');
                    $currentSection.find('.end-date').val('').attr('disabled', true)
                } else {
                    $currentSection.find('.end-date').val(element.end_date.substr(0, 10)).attr('disabled', false);
                }
            });
        }
    }

    initSelect2($field) {
        $field.select2();
    }

    addAnotherField() {
        this.fieldCount++;
        this.addOptionToQualification(this.fieldCount, null, null)
        let $duplicate = this.$originalContent.clone();
        $duplicate.find('[data-field]').attr('data-field', this.fieldCount);
        let $duplicatedType = $duplicate.find('.institution-type');
        let $duplicatedInstitution = $duplicate.find('.institution');
        let $duplicatedField = $duplicate.find('.subjects');
        let $duplicatedCourse = $duplicate.find('.course');
        let $duplicatedStartDate = $duplicate.find('.start-date');
        let $duplicatedEndDate = $duplicate.find('.end-date');
        let $duplicatedInProgress = $duplicate.find('.still-in-progress');
        let $duplicatedFileUpload = $duplicate.find('.visible-document-upload');

        try {
            $duplicatedFileUpload.closest('.file').find('.filename').text(this.qualificationObjects[this.fieldCount]['qualification_documents'][0]['file_name']);
        } catch (error) {
            $duplicatedFileUpload.closest('.file').find('.filename').text('');
            $duplicatedFileUpload.closest('.education-upload').siblings('a').remove();
        }

        try {
            $duplicatedCourse.val(this.qualificationObjects[this.fieldCount]['course_studied']);
        } catch (error) {
            $duplicatedCourse.val('');
        }

        this.$additionalFields.append($duplicate);

        let $clonedFile = $('#education_details_form').find('.input.file').first().clone().val('');
        $('#education_details_form .hide').append($clonedFile);

        this.initDatePicker($duplicatedStartDate);
        this.initDatePicker($duplicatedEndDate);
        this.initSelect2($duplicatedType);
        this.initSelect2($duplicatedField);

        $duplicatedType.on('change', (e) => {
            this.addOptionToQualification(this.fieldCount, 'institution_type_id', e.target.value);
        });

        $duplicatedInstitution.on('change', (e) => {
            this.addOptionToQualification(this.fieldCount, 'institution_title', e.target.value);
        });

        $duplicatedField.on('change', (e) => {
            let values = $(e.target).val();
            this.qualificationObjects[this.fieldCount]['subjects'] = {
                //Need to check if it is single or multiple and patch accordingly
                _ids: isNaN(values) ? values : [values]
            };
            $(document).trigger('qualificationChange');
        }).trigger('change');

        $duplicatedStartDate.on('change', (e) => {
            this.addOptionToQualification(this.fieldCount, 'start_date', e.target.value);
        });

        $duplicatedEndDate.on('change', (e) => {
            this.addOptionToQualification(this.fieldCount, 'end_date', e.target.value);
        });

        $duplicatedInProgress.on('change', (e) => {
            delete this.qualificationObjects[this.fieldCount]['end_date'];
            $duplicatedEndDate.attr('disabled', $(e.target).is(':checked')).val('');
            $(document).trigger('qualificationChange');
        });

        this.assignValidation(this.qualificationObjects[0]['qualification_level_id']);

        return $duplicate;
    }

    clearEducation(start, end, clearFields) {
        for (let index = start; index < end; index++) {
            delete this.qualificationObjects[index];      
        }

        if (clearFields) {
            $('[data-education-level]').find('input[type="text"]').val('');
            $('[data-education-level]').find('.filename').text('');
            $('[data-education-level]').find('.education-upload').siblings('a').remove();
        }
    }
}